// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getNotifyStyle } from "@steiner/App/Components/Notify";
import { orderTotalDisplaySharedStyles } from "@steiner/App/SharedStyles/OrderTotalDisplaySharedStyles";
import { cartTotalStyles } from "@steiner/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitCartTotal";
import { addToCartButtonStyles } from "@steiner/XDL/PreStyle/button";
import { mergeWithCss } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

cartTotalStyles.fullWidthGridItem = {
    ...orderTotalDisplaySharedStyles.fullWidthGridItem,
};

cartTotalStyles.styledHr = {
    ...orderTotalDisplaySharedStyles.styledHrGridItem,
};

cartTotalStyles.placeOrderButton = {
    ...mergeWithCss(addToCartButtonStyles, {
        css: css`
            width: 100%;
        `,
    }),
};

cartTotalStyles.submitForApprovalButton = {
    variant: "tertiary",
    css: css`
        width: 100%;
    `,
};

cartTotalStyles.availabilityErrorMessageText = {
    ...getNotifyStyle("danger"),
};

cartTotalStyles.placeOrderErrorMessageText = {
    ...getNotifyStyle("danger"),
};

cartTotalStyles.invalidEditableAddressErrorMessageText = {
    ...getNotifyStyle("danger"),
};

cartTotalStyles.invalidAddressErrorMessageText = {
    ...getNotifyStyle("danger"),
};

cartTotalStyles.invalidPriceErrorMessageText = {
    ...mergeWithCss(getNotifyStyle("danger"), {
        css: css`
            display: inline-block;
            margin-bottom: 0;
        `,
    }),
};

cartTotalStyles.buttonsGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
    `,
};